/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseShowroomDetailsFragment} from '@amblique/contentful/app/contentful/fragments/showroom-details/base-showroom-details.fragment';
import {ActionLinksFragment} from '@amblique/contentful/app/contentful/fragments/action-links/action-links.fragment';
import {HeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner/hero-banner.fragment';
import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {SeoFragment} from '@amblique/contentful/app/contentful/fragments/seo/seo.fragment';

export const FullShowroomDetailsFragment = gql`
  ${ActionLinksFragment}
  ${BaseShowroomDetailsFragment}
  ${HeroBannerFragment}
  ${IconFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${SeoFragment}

  fragment FullShowroomDetailsFragment on ShowroomDetails {
    ...BaseShowroomDetailsFragment

    countries {
      ...ActionLinksFragment
    }
    featuredImage {
      ...ImageFragment
    }
    headerBlock {
      ...HeroBannerFragment
    }
    onDisplayCollection {
      items {
        __typename
        ... on Icon {
          ...IconFragment
        }
      }
    }
    relatedPages {
      ...ActionLinksFragment
    }
    seo {
      ...SeoFragment
    }
    storeImages {
      ...LinkFragment
    }
  }
`;
